<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-calendar-alt"></i> Add Hold Event
    <app-page-help articleId="cbifghdzxx"></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <!-- Title -->
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input type="text" matInput required placeholder="Title" formControlName="title" tabindex="1" />
          <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('required')">
            Title is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('maxlength')">
            Title must be at most <strong>50</strong> characters long
          </mat-error>
          <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('allSpaces')">
            Title cannot be spaces alone.
          </mat-error>
          <mat-hint align="end">{{ form.get('title').value.length || 0 }}/50</mat-hint>
        </mat-form-field>
      </div>

      <!-- From -->
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            matInput
            [matDatepicker]="startPicker"
            [min]="minDateDefault"
            [max]="maxStartDate.value || maxDateDefault"
            placeholder="From"
            [required]="true"
            (focus)="startPicker.open()"
            formControlName="start"
            tabindex="4"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')">
            Value is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <!-- Type -->
      <div class="col-sm-6">
        <mat-form-field [floatLabel]="'never'" class="mat-block">
          <mat-select
            matTooltip="Hold Events will be sent to your connected channels and calendars."
            matTooltipPosition="above"
            matTooltipClass="text-center"
            formControlName="type"
            placeholder="Type"
            [required]="true"
            [tabIndex]="2"
          >
            <mat-option *ngFor="let type of types" [value]="type.id">{{ type.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')">
            Type is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- To -->
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            matInput
            [matDatepicker]="endPicker"
            [max]="maxDateDefault"
            [min]="minEndDate.value || minDateDefault"
            placeholder="Until"
            [required]="true"
            (focus)="endPicker.open()"
            formControlName="end"
            tabindex="4"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
          <mat-error *ngIf="form.get('end').touched && form.get('end').hasError('required')">
            Value is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <!-- Rentals -->
      <div class="col-sm-6">
        <app-select-search
          bindValue="id"
          bindLabel="name"
          floatLabel="never"
          [items]="rentals$ | async"
          [ctrl]="form.get('rentals')"
          placeholder="Select Rental(s)"
          [tabIndex]="3"
        >
          <ng-container class="error-container">
            <mat-error> Rental(s) is <strong>required</strong> </mat-error>
          </ng-container>
        </app-select-search>
      </div>

      <!-- Expires -->
      <div class="col-sm-6">
        <mat-form-field class="mat-block">
          <input
            matInput
            [matDatepicker]="expiresPicker"
            [max]="maxDateDefault"
            [min]="minExpirationDate || minDateDefault"
            placeholder="Expiration"
            matTooltip="This Hold Event will be automatically removed from Tokeet on the expiration date."
            matTooltipPosition="above"
            matTooltipClass="text-center"
            (focus)="expiresPicker.open()"
            formControlName="expires"
            tabindex="6"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="expiresPicker"></mat-datepicker-toggle>
          <mat-datepicker #expiresPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <mat-checkbox
          matTooltip="Check this box and Tokeet will keep shifting your hold event forward by 1 day every 24 hours."
          matTooltipPosition="above"
          matTooltipClass="text-center"
          (change)="onRollingChanged($event)"
          >Roll Forward</mat-checkbox
        >
      </div>
    </div>
  </form>
</div>
<div class="modal-footer d-flex align-items-center">
  <app-color-picker
    class="mr-auto ml-0"
    colors="inquiry"
    (change)="onChangeColor($event)"
    matTooltip="Set hold event color"
    matTooltipPosition="above"
  >
  </app-color-picker>
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase" tabindex="8">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="create(form)" type="button" class="btn btn-success text-uppercase create-btn" tabindex="7">
    <i class="fal fa-plus"></i> create
  </button>
</div>
